var map = {
	"./en-US.js": [
		"./src/locale-config/en-US.js",
		"src_locale-config_en-US_js"
	],
	"./ja.js": [
		"./src/locale-config/ja.js",
		"src_locale-config_ja_js"
	],
	"./zh-TW.js": [
		"./src/locale-config/zh-TW.js",
		"src_locale-config_zh-TW_js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/locale-config lazy recursive ^\\.\\/.*\\.js$";
module.exports = webpackAsyncContext;